import React from "react";
import { Plus } from "lucide-react";
import { faqs } from "../mock";
import useReveal from "../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function FAQ() {
  const [ref, visible] = useReveal();
  return (
    <section className="py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-[820px] mx-auto reveal ${visible ? "is-visible" : ""}`}>
        <h2 className="text-center font-serif-display text-[#9E2B25] text-[46px] md:text-[64px] mb-14">
          Questions &amp; Answers
        </h2>
        <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#211E1A]/15">
              <AccordionTrigger className="text-left text-[13px] md:text-[14px] uppercase tracking-widest-2 font-semibold text-[#211E1A] hover:no-underline py-6 [&>svg]:hidden group">
                <span>{f.q}</span>
                <Plus
                  size={20}
                  className="text-[#9E2B25] shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45"
                />
              </AccordionTrigger>
              <AccordionContent className="text-[#4a443d] leading-relaxed text-[15px] pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
